import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { InputField } from '../../../../../../../healtheraComponents';
import { StyledQuestionFieldContainer } from '../styles';

interface Props {
  control: Control<EditableQuestion>;
}

const TitleEditor = ({ control }: Props) => (
  <Controller
    control={control}
    name="question"
    rules={{
      required: { value: true, message: 'Question title is required' },
      pattern: { value: /\S/, message: 'Question title must be non empty string' }
    }}
    render={({ field: { ref, ...otherField }, formState }) => (
      <StyledQuestionFieldContainer>
        <InputField
          {...otherField}
          multiline
          margintop="0"
          label="Question title"
          inputRef={ref}
          required
          error={formState.errors.question?.message}
        />
      </StyledQuestionFieldContainer>
    )}
  />
);
export default TitleEditor;
